// ═══════════════════════════════════════════════════════════════════
//  modules/documents/ContratsModule.js
//  ContratsModule
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { CrudHeader } from "../../composants/CrudHeader";
import { CrudModal } from "../../composants/CrudModal";
import { DataTable } from "../../composants/DataTable";
import { fmtEur } from "../../socle/format";
import { useCrud } from "../../socle/hooks";
import { THEME } from "../../socle/theme";

// ═══════════════ 3) CONTRATS & PRESTATAIRES ═══════════════
export function ContratsModule({ token, onBack }) {
  const { items, loading, create, update, remove } = useCrud(token, "/api/documents/contrats");
  const [edit,setEdit]=useState(undefined); // undefined=fermé, null=nouveau, obj=édition
  const STATUTS={en_cours:"En cours",livre:"Livré",paye:"Payé"};
  const fields=[
    {key:"prestataire_nom",label:"Prestataire",full:true,placeholder:"ex : Mack (Fiverr)"},
    {key:"prestataire_contact",label:"Contact"},
    {key:"prestataire_role",label:"Rôle",placeholder:"Modeleur 3D…"},
    {key:"objet",label:"Objet",full:true,type:"textarea",placeholder:"ex : modèle 3D du Boux"},
    {key:"montant",label:"Montant (€)",type:"number",numeric:true},
    {key:"echeance",label:"Échéance",type:"date"},
    {key:"statut",label:"Statut",type:"select",options:Object.entries(STATUTS).map(([v,l])=>({value:v,label:l}))},
    {key:"livrables",label:"Livrables",full:true,type:"textarea"},
  ];
  const cols=[
    {key:"prestataire_nom",label:"Prestataire",width:"1fr",render:(r)=><span style={{fontWeight:600}}>{r.prestataire_nom}</span>},
    {key:"objet",label:"Objet",width:"1.4fr",render:(r)=><span style={{color:THEME.textMuted}}>{r.objet}</span>},
    {key:"montant",label:"Montant",width:"110px",align:"right",render:(r)=>fmtEur(r.montant)},
    {key:"echeance",label:"Échéance",width:"110px",render:(r)=>r.echeance?r.echeance.slice(0,10):"—"},
    {key:"statut",label:"Statut",width:"100px",render:(r)=><span style={{color:r.statut==="paye"?THEME.emerald:r.statut==="livre"?THEME.accent:THEME.amber}}>{STATUTS[r.statut]||r.statut}</span>},
  ];
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <CrudHeader onBack={onBack} title="📜 Contrats & prestataires" onAdd={()=>setEdit(null)} addLabel="+ Nouveau contrat" />
      {loading ? <div style={{color:THEME.textMuted,padding:20}}>Chargement…</div> :
        <DataTable columns={cols} rows={items} onEdit={setEdit} onDelete={(id)=>{if(window.confirm("Supprimer ce contrat ?"))remove(id);}} empty="Aucun contrat enregistré." />}
      {edit!==undefined && <CrudModal title={edit?"Éditer le contrat":"Nouveau contrat"} fields={fields} initial={edit} onClose={()=>setEdit(undefined)} onSave={async(b)=>{ edit?await update(edit.id,b):await create(b); setEdit(undefined); }} />}
    </div>
  );
}
